module.exports = __webpack_public_path__ + "img/1.d37f6c11.png";